
import { defineComponent, computed } from 'vue'
import TextAlert from '@/components/molecules/TextAlert.vue'
import InputImageFile from '@/components/molecules/InputImageFile.vue'
import DssIcon from '@/components/atoms/DssIcon.vue'

export default defineComponent({
  name: 'FileUpload',
  components: {
    TextAlert,
    InputImageFile,
    DssIcon
  },
  props: {
    modelValue: {
      type: FileList
    },
    errMsgFlg: {
      type: Boolean
    }
  },
  setup (props, { emit }) {
    const file = computed({
      get: () => props.modelValue,
      set: (file) =>
        emit('update:modelValue', file)
    })

    return {
      props,
      file,

      fileUpload (fileList: FileList) {
        file.value = fileList
      }
    }
  }
})
